import LambdaUtil from 'APP_ROOT/components/aws/lambda/lambdaUtil';

export default class FacesDataSource {

    constructor(user) {
        if (!user || !user.stage) throw new Error("need a valid user");
        this.stage = user.stage;
    }

    static with(user) {
        return new FacesDataSource(user);
    }

    /**
     * sets identity name
     * returns a Promise
     **/
    setIdentityName(identityId, name) {
        return LambdaUtil.setIdentityName(this.stage, identityId, name);
    }

    /**
     * deletes images in the kloud based on the array of faceIds passed
     * returns a Promise
     **/
    deleteIdentityFaces(faceIds) {
        return LambdaUtil.deleteIdentityFaces(this.stage, faceIds);
    }

    /**
     * unassign images in the kloud based on the associated array of faceIds passed
     * returns a Promise
     **/
     unassignIdentityFaces(faceIds) {
        return LambdaUtil.unassignIdentityFaces(this.stage, faceIds);
    }

    /**
     * Deletes an array of identities.  Used by "Delete All New"
     **/
    deleteIdentities(identityIds) {
        return LambdaUtil.deleteIdentities(this.stage, identityIds);
    }

    /**
     * merge all identities specified in the identityIds array into the first
     * identityId in the array.
     **/
    mergeIdentities(identityIds) {
        return LambdaUtil.mergeIdentities(this.stage, identityIds);
    }

    /**
     * sets the profile face id for an identity
     * returns a Promise
     **/
    setIdentityProfileFace(identityId, faceId) {
        return LambdaUtil.setIdentityProfileFace(this.stage, identityId, faceId);
    }
}
